import Container from "../common/Container";
import Title from "../common/Title";
import Video from "../common/Video";

const WeAre = () => (
  <Container large className="bg-primary-black pb-20 md:pb-40">
    <Title
      description="Discover the essence of ultroNeous through our video. Get to know our team, vision, and
commitment to excellence."
      descriptionClass="text-base text-white text-center font-light md:px-64 pb-10 md:pb-24"
      subTitle="Who We Are"
      subTitleClass="text-4xl md:text-6xl text-white text-center mb-4 xl:pb-2"
    />
    <Video
      className="rounded-md md:rounded-2xl w-full h-52 md:h-[700px]"
      width="100%"
    />
  </Container>
);
export default WeAre;
